module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0125-mjigyosyo/mjigyosyo.component.css
// module id = ./src/app/a0125-mjigyosyo/mjigyosyo.component.css
// module chunks = main